function NoManagingOrgsCtrl($state, SessionsService, $rootScope) {
  "ngInject";

  let vm = this;
  vm.paulsCurrentDistributorName = $rootScope.paulsCurrentDistributorName;

  if (SessionsService.getDistributors().length > 0) {
    $state.go('main.managing_org_selection')
  }
  return vm;
}

export {NoManagingOrgsCtrl}
